import { useEffect, useState } from "react";
import { audioManager } from "../lib/audioManager";

export function VolumeControl() {
  const [volume, setVolume] = useState(() => Math.round(audioManager.getVolume() * 100));

  useEffect(() => audioManager.subscribe(() => {
    setVolume(Math.round(audioManager.getVolume() * 100));
  }), []);

  return (
    <label className="flex items-center gap-2 text-sm text-violet-300/80 min-w-[140px]">
      <span aria-hidden>🔊</span>
      <input
        type="range"
        min={0}
        max={100}
        value={volume}
        className="flex-1 h-1.5 accent-orange-400 cursor-pointer"
        aria-label="Volume du site"
        onInput={(e) => {
          const v = Number(e.currentTarget.value);
          setVolume(v);
          audioManager.setVolume(v / 100);
        }}
      />
      <span className="tabular-nums w-8 text-right text-xs">{volume}%</span>
    </label>
  );
}
